import type { Role } from '@/entities/user';

export const accountingAccessRoles = [
  'admin',
  'accountant',
  'finance_admin',
] as const satisfies readonly Role[];
